<script>
import { VSelect } from 'vuetify/lib'

export default {
  extends: VSelect,
  data(){
    return {
      timeout: null,
    }
  },
  watch: {
    isMenuActive(val) {
      if (val) {
        clearTimeout(this.timeout);
        this.$emit('openMenu', val);
      } else {
        this.timeout = setTimeout(() => {
          this.$emit('openMenu', val);
        }, 500);
      }
    }
  }
}
</script>
